import React, { useState } from 'react';
import './common.css';

const Input = ({ label, type = 'text', value, onChange, error, placeholder, name, disabled = false }) => {
  const [focused, setFocused] = useState(false);
  
  const inputClass = `neon-input ${error ? 'neon-input-error' : ''} ${focused ? 'focused' : ''} ${disabled ? 'disabled' : ''}`;

  return (
    <div className="neon-input-container">
      <label className="neon-input-label">{label}</label>
      <div className="neon-input-wrapper">
        <input
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          placeholder={placeholder}
          disabled={disabled}
          className={inputClass}
        />
        <div className={`neon-input-glow ${focused ? 'visible' : ''}`}></div>
      </div>
      {error && (
        <p className="neon-input-error-message">
          <span>⚠</span>
          {error}
        </p>
      )}
    </div>
  );
};

export default Input;